import config from '#/config';

const prefix = config.app.urlPrefix;

export const getAPIBaseUrl = () => {
  return config.accedoOne.middlewareUrl
    ? config.accedoOne.middlewareUrl
    : prefix;
};
